/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface LockCardOnFraudDetectedRequestOneOf1
 */
export interface LockCardOnFraudDetectedRequestOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof LockCardOnFraudDetectedRequestOneOf1
     */
    'lockType': LockCardOnFraudDetectedRequestOneOf1LockTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LockCardOnFraudDetectedRequestOneOf1
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof LockCardOnFraudDetectedRequestOneOf1
     */
    'triggeredTransactionId': string;
}

export const LockCardOnFraudDetectedRequestOneOf1LockTypeEnum = {
    other: 'OTHER'
} as const;

export type LockCardOnFraudDetectedRequestOneOf1LockTypeEnum = typeof LockCardOnFraudDetectedRequestOneOf1LockTypeEnum[keyof typeof LockCardOnFraudDetectedRequestOneOf1LockTypeEnum];


